import { render } from "./AccessDenied.vue?vue&type=template&id=eb68a538&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=eb68a538&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb68a538"]])

export default __exports__